import React from 'react'
import { Helmet } from 'react-helmet-async'

export default function HelmetTitle(props) {

  const { title, meta, link, script } = props

  return (
    <Helmet>
      {meta}
      <title>
        {
          title ?
          `${title} | Aphrodite Healthcare` :
          'Aphrodite - A healthcare website theme'
        }
      </title>
      {link}
      {script}
    </Helmet>
  )
}
